import React, { FC } from 'react';
import { observer } from 'mobx-react';

import StaticFrame from '../../Frames/StaticFrame/StaticFrame';
import { MemoCardFrame } from '../../Diary/MemoCard/MemoCardFrame';
import { PresentText } from '../Text/PresentText';
import { SessionPresentationProps } from '../config';
import { useStores } from '../../../hooks/useStores';

const isMemoNode = (node: any): boolean => node?.dataRef?.sessionStep?.frame?.type === 'memoCard';

/**
 * A FRAME step: a page shown as is. Its layout picks the presenter — rich
 * text (the step's text), a memo card, or the illustrated frames. Adjacent
 * memo cards form a deck: the card shows its position in it.
 */
const _PresentFrame: FC<SessionPresentationProps> = props => {
  const rootStore = useStores();
  const { treeNav } = rootStore;
  const frame = treeNav.content.sessionStep?.frame;
  if (!frame || frame.type === 'text') {
    return <PresentText {...props} />;
  }
  if (frame.type === 'memoCard') {
    // the run of memo cards around the current one, in tree order
    const nodes: any[] = (treeNav.tree?.nodes as any[]) || [];
    const current = nodes.findIndex(node => node.key === treeNav.current);
    let first = current;
    while (first > 0 && isMemoNode(nodes[first - 1])) {
      first--;
    }
    let last = current;
    while (last < nodes.length - 1 && isMemoNode(nodes[last + 1])) {
      last++;
    }
    const dots = current >= 0 ? { index: current - first, total: last - first + 1 } : undefined;
    return <MemoCardFrame staticFrame={frame} dots={dots} />;
  }
  return <StaticFrame staticFrame={frame} />;
};

export const PresentFrame = observer(_PresentFrame);
